import * as React from 'react'
import { Button } from '../../../shared-components/Button'
import { ErrorMessage } from '../../../shared-components/ErrorMessage'
import { InputText } from '../../../shared-components/InputText'
import { useScreenTracking } from '../../../shared-hooks/useScreenTracking'
import { track } from '../../../utils/analytics'
import { SignupCard } from '../SignupCard'
import { SSOStepProps } from './SSOFlow'

type SMSVerificationProps = SSOStepProps & {
  sessionId: string
  onResendRequest: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>
}

export const SMSVerification = ({
  sessionId,
  makeSSORequest,
  onResendRequest,
}: SMSVerificationProps): JSX.Element => {
  useScreenTracking('SMSVerificationView', 'View SMS verficiation screen')

  const [smsCode, setSMSCode] = React.useState('')
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setErrorMessage('')

    track('AttemptSMS', 'Uber attempt SMS')

    const body = {
      session_id: sessionId,
      stage: 'sign_in',
      event_type: 'TypeSMSOTP',
      credentials: {
        sms_code: smsCode,
      },
    }

    try {
      await makeSSORequest(body, 'Invalid pin entered. Please try again.')
      track('UberSMSSuccess', 'Uber SMS success')
    } catch (error) {
      track('UberSMSFailure', 'Uber SMS failure')
      setIsSubmitting(false)
      setErrorMessage(error?.message)
    }
  }

  return (
    <SignupCard
      heading='Enter SMS Pin'
      subheading='Uber will send you a 4 digit pin code to the phone number you submitted. Enter it below.'
    >
      <form className='flex flex-col gap-4' onSubmit={onSubmit}>
        <InputText
          pattern='\d{4}'
          placeholder='4 Digit Pin Code'
          autoComplete='off'
          // autoComplete='one-time-code' // Doesn't work on Chrome for some reason.
          value={smsCode}
          onChange={(event) => setSMSCode(event.target.value)}
          disabled={isSubmitting}
          maxLength={4}
          required
        />
        <ErrorMessage>{errorMessage}</ErrorMessage>
        <button
          type='button'
          className={`text-left text-sm font-extralight py-2 pl-1 rounded text-body-black hover-hover:hover:bg-blue-50 hover-hover:hover:bg-opacity-50 active:bg-blue-50 active:bg-opacity-50${
            errorMessage ? '' : ' -mt-6'
          }`}
          onClick={(event) => {
            track('ResendSMSCode', 'Resend SMS code')
            onResendRequest(event)
          }}
        >
          Didn't receive a code?
        </button>
        <Button type='submit' isSubmitting={isSubmitting}>
          Continue
        </Button>
      </form>
    </SignupCard>
  )
}
